// Stand-in company logo. README says assets are CSS-drawn squares with initials —
// Clearbit/Brandfetch integration is future work.

import type { CSSProperties } from 'react';

interface Props {
  name: string;
  size?: number;
  style?: CSSProperties;
}

export default function LogoSquare({ name, size = 36, style }: Props) {
  return (
    <div
      className="logo-sq"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36), ...style }}
    >
      {name[0]?.toUpperCase() || '·'}
    </div>
  );
}
